(function () {
  const LOCK_CLASS = 'is-market-switching';
  // Releases the lock if the localization navigation never happens (stalled or silently cancelled submit).
  const FAILSAFE_TIMEOUT = 12000;

  const CART_SELECTORS = [
    '#checkout',
    'cart-items-component button',
    'cart-items-component input',
    '.cart-discount button',
    '.cart-discount input',
  ];
  const CART_FORMS = '#cart-form, .cart-discount__form';

  let failsafeTimer = null;
  // Cart-only lock (post-switch cart re-sync in cart-market-validation.js) leaves add-to-cart alone,
  // so the PDP `pdp_add` auto-submit that lands on the same page still goes through.
  let cartOnly = false;

  function blockEvent(event) {
    if (cartOnly && !(event.target instanceof Element && event.target.matches(CART_FORMS))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function lockCartForMarketSwitch({ cartOnly: cartOnlyLock = false } = {}) {
    const root = document.documentElement;
    if (root.classList.contains(LOCK_CLASS)) return;

    cartOnly = cartOnlyLock;
    root.classList.add(LOCK_CLASS);

    const selectors = cartOnly ? CART_SELECTORS : [...CART_SELECTORS, 'button[name="add"]'];
    document.querySelectorAll(selectors.join(',')).forEach((element) => {
      if (element.disabled) return;
      element.disabled = true;
      element.dataset.marketSwitchDisabled = 'true';
    });

    document.body.setAttribute('aria-busy', 'true');

    document.addEventListener('submit', blockEvent, true);
    failsafeTimer = setTimeout(unlockCartForMarketSwitch, FAILSAFE_TIMEOUT);
  }

  function unlockCartForMarketSwitch() {
    clearTimeout(failsafeTimer);
    failsafeTimer = null;

    const root = document.documentElement;
    if (!root.classList.contains(LOCK_CLASS)) return;

    root.classList.remove(LOCK_CLASS);
    document.removeEventListener('submit', blockEvent, true);

    document.querySelectorAll('[data-market-switch-disabled]').forEach((element) => {
      element.disabled = false;
      delete element.dataset.marketSwitchDisabled;
    });

    document.body.removeAttribute('aria-busy');
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) unlockCartForMarketSwitch();
  });

  window.lockCartForMarketSwitch = lockCartForMarketSwitch;
  window.unlockCartForMarketSwitch = unlockCartForMarketSwitch;
})();
